import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { FaEnvelope, FaPhone, FaClock, FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';
import SEO from '../components/SEO';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Create mailto link with form data
    const mailtoLink = `mailto:itworldwani@gmail.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\n\nMessage:\n${formData.message}`
    )}`;
    window.location.href = mailtoLink;
    setSubmitted(true);
  };

  return (
    <>
      <SEO 
        title="Contact Us - IT World"
        description="Get in touch with IT World for software solutions, support, and inquiries. We're here to help!"
      />
      <div className="bg-primary text-white py-5">
        <Container>
          <h1 className="text-center mb-3">Contact Us</h1>
          <p className="text-center lead">We'd Love to Hear From You</p>
        </Container>
      </div>

      <Container className="py-5">
        <Row>
          {/* Contact Information */}
          <Col lg={5} className="mb-4">
            <h2 className="mb-4">Get In Touch</h2>
            <p className="text-muted mb-4">
              Have questions about our products or services? Need technical support? 
              We're here to help! Reach out to us through any of the following channels.
            </p>

            <Card className="border-0 shadow-sm mb-4">
              <Card.Body>
                <div className="d-flex align-items-center mb-3">
                  <FaPhone className="text-primary me-3" size={24} />
                  <div>
                    <h6 className="mb-0">Phone</h6>
                    <a href="tel:+919561306384" className="text-decoration-none">+91 9561306384</a>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <FaWhatsapp className="text-success me-3" size={24} />
                  <div>
                    <h6 className="mb-0">WhatsApp</h6>
                    <a href="https://wa.me/919561306384" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                      +91 9561306384
                    </a>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <FaEnvelope className="text-primary me-3" size={24} />
                  <div>
                    <h6 className="mb-0">Email</h6>
                    <a href="mailto:itworldwani@gmail.com" className="text-decoration-none">
                      itworldwani@gmail.com
                    </a>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <FaClock className="text-primary me-3" size={24} />
                  <div>
                    <h6 className="mb-0">Business Hours</h6>
                    <p className="mb-0 text-muted">Monday - Saturday: 11:00 AM - 7:00 PM IST</p>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <FaMapMarkerAlt className="text-primary me-3" size={24} />
                  <div>
                    <h6 className="mb-0">Location</h6>
                    <p className="mb-0 text-muted">India</p>
                  </div>
                </div>
              </Card.Body>
            </Card>

            <Card className="border-0 shadow-sm bg-light">
              <Card.Body>
                <h5 className="mb-3">Quick Support</h5>
                <p className="text-muted mb-3">
                  For faster response, please include your order ID (if applicable) 
                  when contacting us about an existing purchase.
                </p>
                <p className="mb-0 text-muted">
                  <strong>Response Time:</strong> We typically respond within 24 hours during business days.
                </p>
              </Card.Body>
            </Card>
          </Col>

          {/* Contact Form */}
          <Col lg={7}>
            <Card className="border-0 shadow-sm">
              <Card.Body className="p-4">
                <h2 className="mb-4">Send Us a Message</h2>
                
                {submitted && (
                  <Alert variant="success" className="mb-4">
                    Thank you for reaching out! Your email client should open with your message. 
                    If it doesn't, please email us directly at itworldwani@gmail.com
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Your Name *</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Enter your name"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Email Address *</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Enter your email"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="Enter your phone number"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Subject *</Form.Label>
                        <Form.Select
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select a subject</option>
                          <option value="General Inquiry">General Inquiry</option>
                          <option value="Product Support">Product Support</option>
                          <option value="Order Issue">Order Issue</option>
                          <option value="Refund Request">Refund Request</option>
                          <option value="Technical Support">Technical Support</option>
                          <option value="Partnership">Partnership</option>
                          <option value="Other">Other</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-4">
                    <Form.Label>Your Message *</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Please describe your inquiry in detail..."
                      required
                    />
                  </Form.Group>

                  <Button variant="primary" type="submit" size="lg" className="w-100">
                    Send Message
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ContactUs;
